import { apiGet, apiPost } from './client';
import type { PageViewSummary } from '../types/PageViewSummary';

// POST /api/page-view — best-effort write. The backend returns 204 even when
// the URL doesn't resolve to a Pages.url row (login, deep-links, etc.), so
// the caller doesn't need to special-case the "unknown route" cases.
export function recordPageView(url: string): Promise<void> {
  return apiPost<{ url: string }, void>('/api/page-view', { url });
}

// GET /api/page-view/summary — SysAdmin-only. Returns one row per active
// page in dbo.Pages (LEFT JOIN onto PageViewLog), so dead screens surface
// with lastUsedAt = null.
export function getPageViewSummary(): Promise<PageViewSummary[]> {
  return apiGet<PageViewSummary[]>('/api/page-view/summary');
}
